import { EntryPointSchema } from "#gen/bundles/v1/bundle_pb.js";
import { AssetLoad } from "#lib/api/bundles.js";
import { handlePageLoadError } from "#lib/api/error.js";
import { AssetManager } from "#lib/assetManager.js";
import { Registry } from "#lib/components/page/registry.js";
import { create } from "#lib/protobuf-compat.js";
import type { PageLoadEvent } from "./$types";

export async function load(event: PageLoadEvent) {
	try {
		const data = await event.parent();
		const entryPoint = create(EntryPointSchema, {
			key: event.params.entryKey,
			id: event.params.entrypointId,
		});
		const cookie = event.data.cookie;
		const suite = event.data.suite;
		const brandKit = event.data.brandKit;
		const dpaDomainInfo = event.data.dpaDomainInfo;
		const assetManager = new AssetManager(data.bundleClient, cookie);
		const registry = new Registry(data.registryClient);
		const assetLoad = AssetLoad.fromJson(event.data.assetLoad);
		const modules = event.data.modules;
		const assets: Record<string, AssetLoad> = Object.keys(event.data.assets).reduce(
			(acc, key) => {
				acc[key] = AssetLoad.fromJson(event.data.assets[key]);
				return acc;
			},
			{} as Record<string, AssetLoad>,
		);
		await registry.preload();
		return {
			assetManager,
			cookie,
			entryPoint,
			suite,
			brandKit,
			assetLoad,
			assets,
			resolutions: event.data.resolutions,
			modules,
			registry,
			dpaDomainInfo,
			customCodeHead: event.data.customCodeHead,
		};
	} catch (e) {
		throw handlePageLoadError(e, event.route.id, event.params);
	}
}
